import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Box from 'ui-box';
import { Typography } from 'antd';
import InputSelectField from '../../../components/mobile/form-helpers/InputSelectField';

const { Title } = Typography;

const styles = {
  title: {
    fontWeight: "400", 
    fontSize: "18px", 
    lineHeight: "21px", 
    textAlign: "justify", 
    color: "#404047"
  }
}

function MobileMultipleQuestionsTemplate({
  bodyStyle,
  titleStyle,
  handleChange,
  questions,
  selectStyling
}) {
  const { t } = useTranslation();

  return questions?.length ? questions.map(question => (
    <Box {...bodyStyle}>
      <Box paddingBottom={8} {...titleStyle}>
        <Title level={4} style={styles.title}>
          {t(question.label)}
        </Title>
      </Box>
      <div style={selectStyling}>
        <InputSelectField handleChange={handleChange} name={question.value} options={question.options.filter(option => option.value !== '')} />
      </div>
    </Box>
  )) : null;
}

MobileMultipleQuestionsTemplate.defaultProps = {
  questions: [],
  bodyStyle: {},
  titleStyle: {},
  selectStyling: {}
};

const { shape } = PropTypes;

MobileMultipleQuestionsTemplate.propTypes = {
  questions: shape([]),
  selectStyling: shape({}),
  bodyStyle: shape({}),
  titleStyle: shape({}),
};

export default MobileMultipleQuestionsTemplate;
